
import useFetch from '../hooks/useFetch';

const getNotifications = async (dataRequest) => {
  try {
    return await useFetch.fnPost('home/getNotifications', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const readNotifications = async (dataRequest) => {
  try {
    return await useFetch.fnPost('home/readNotifications', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getProfileEmployed = async (dataRequest) => {
  try {
    return await useFetch.fnPost('home/getProfileEmployee', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const saveLocationEmployee = async (dataRequest) => {
  try {
    return await useFetch.fnPost('home/saveLocationEmployee', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getLocationEmployee = async (dataRequest) => {
  try {
    return await useFetch.fnPost('home/getLocationEmployee', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const requestApi = {
  getNotifications,
  readNotifications,
  getProfileEmployed,
  saveLocationEmployee,
  getLocationEmployee,
}

export default requestApi;